/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanDependenciesRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanDependenciesRoute.tsx';
import PlanDependenciesReportPage, {
	LazyPlanDependenciesReport,
} from './ui/plan-dependencies-report/index-old.tsx';
import { planDependenciesReportPageEntryPoint } from './ui/plan-dependencies-report/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwarePlanDependenciesRouteEntry: Route = createEntry(
	softwarePlanDependenciesRoute,
	() => ({
		group: 'software',

		entryPoint: () => planDependenciesReportPageEntryPoint,

		// eslint-disable-next-line no-restricted-syntax
		component: PlanDependenciesReportPage,
		layout: composeLayouts(globalLayout, planLayout),

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarPlanResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
			...getPlansBacklogResource(),
			advancedRoadmapsReduxStoreStateResource,
			advancedRoadmapsLastVisitedProgramBoardIdResource,
		],

		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},

		navigation: {
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanDependenciesReport],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
